import { authorizedRequests } from "../axios/axios-config";
import api from "../axios/axios-config";

export const getBillings = async () => {
	try {
		let response = await api.get(
			"payment/listOfPayments",

			{
				headers: {
					Authorization: localStorage.getItem("token"),
				},
			},
		);
		return response?.data?.data;
	} catch (error) {
		console.log("ERROR", error);
		return error?.response?.data;
	}
};

export const getBillingByPatient = async (id) => {
	const { error, result } = await authorizedRequests({
		url: "payment/listOfPaymentsByPatientId",
		method: "post",
		data: {
			patientId: id,
		},
	});
	if (error) {
		return { error };
	}
	return { result: result.data };
};

export const getBillingByStaffId = async (id) => {
	const response = await authorizedRequests({
		url: "payment/listOfPaymentsByStaffId",
		method: "post",
		data: {
			staffId: id,
		},
	});
	return response;
};

export const updateBilling = async (data) => {
	const response = await authorizedRequests({
		url: "payment/updatePayment",
		method: "post",
		data,
	});
	return response;
};
